import { Navigate, Route, Routes } from 'react-router-dom';

import { DocsPage } from './pages/DocsPage';
import { EditPage } from './pages/EditPage';
import { Layout } from './components/Layout';
import { useSession } from './auth/session';

export default function App() {
  const { loading } = useSession();

  if (loading) {
    return (
      <div className="boot">
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DocsPage />} />
        <Route path="/edit" element={<EditPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
